module.exports = new __parcel__URL__("endless-summer-vacation.eb111709.jpg").toString();